import { css } from 'aphrodite';
import * as React from 'react';
import { PUBLIC_API_SCOPES } from '../../../../utils/publicApiScopes';
import { Checkbox } from '../../../components-v2/Checkbox';
import { FieldContent, FieldDescription, FieldTitle } from '../../../components-v2/Field';
import { Label } from '../../../components-v2/Label';
import { Pill } from '../../../components-v2/Pill';
import { styleSheet } from './styles';

interface IProps {
	value: string[];
	onChange: (scopes: string[]) => void;
}

export const PublicApiScopePicker: React.FC<IProps> = ({ value, onChange }) => {
	const toggle = (scope: string, checked: boolean) => {
		onChange(checked ? [...value, scope] : value.filter(s => s !== scope));
	};

	return (
		<div className={css(styleSheet.scopeList)}>
			{PUBLIC_API_SCOPES.map(scope => {
				const labelStyles = [scope.comingSoon ? styleSheet.scopeDisabled : styleSheet.scopeOption];
				if (scope.description) {
					labelStyles.push(styleSheet.describedScope);
				}

				return (
					<Label key={scope.value} styles={labelStyles}>
						<Checkbox
							styles={scope.description ? [styleSheet.describedScopeCheckbox] : []}
							disabled={scope.comingSoon}
							checked={!scope.comingSoon && value.includes(scope.value)}
							onCheckedChange={checked => toggle(scope.value, checked === true)}
						/>
						<FieldContent>
							<FieldTitle>
								{scope.value}
								{scope.comingSoon ? <Pill variant='label' color='gray' label='Coming Soon' /> : null}
							</FieldTitle>
							{scope.description ? (
								<FieldDescription styles={[styleSheet.scopeDescription]}>{scope.description}</FieldDescription>
							) : null}
						</FieldContent>
					</Label>
				);
			})}
		</div>
	);
};
